import { MassBar } from '../../design-system/composition/mass-bar';
import { FatLeanChart } from '../../design-system/composition/fat-lean-chart';
import { CoachCard } from '../../design-system/concept/coach-card';
import { currentConfig } from '../../lib/domainConfig';
import type { CompositionSeries } from '../../lib/dashboard/composition';

/**
 * The dashboard's Composition block: the mass bar for the latest weighed scan
 * and, with two or more, the fat-against-lean trend.
 *
 * Muscle mass is gated here, on the experience: `showMuscleMass` is on for
 * dev.sizewall.com only, but only ResultPage read it, so the dashboard showed
 * a muscle split on app and retail. Off, lean is one figure.
 *
 * Composition is kilograms through and through. With no weighed scan it was
 * an empty grid cell; it says what it needs instead.
 */
export const CompositionPanel: React.FC<{
  series: CompositionSeries | null;
  goalFatKg: number | null;
  clientName: string;
}> = ({ series, goalFatKg, clientName }) => {
  const showMuscle = currentConfig.showMuscleMass;
  if (series?.latest) {
    return (
      <>
        <MassBar point={series.latest} showMuscle={showMuscle} />
        {series.points.length > 1 && <FatLeanChart series={series} goalFatKg={goalFatKg} />}
      </>
    );
  }
  return (
    <CoachCard title="Composition" testId="composition-needs-weight" className="h-full">
      <p className="text-[12.5px] leading-relaxed text-foreground-soft">
        {showMuscle
          ? 'Fat, muscle and other lean mass are split in kilograms'
          : 'Fat and lean mass are split in kilograms'}
        , which needs a weight on the scan. None of {clientName}'s scans were weighed.
      </p>
    </CoachCard>
  );
};
